<script>
	import FormRow from "./FormRow.svelte";
	import FormColumn from "./FormColumn.svelte";
	import Contact from "./Contact.svelte";
	import Checkbox from "./Checkbox.svelte";

	import ContactModel from "../models/Contact";
	import AddressModel from "../models/Address";

	export let contact = null;
	export let jointHoldings = null;
	export let authorisedToAct = false;
	export let isRegistrationUpdate = false;
	export let disabled = null;
	export let required = null;

	let disableJoint1 = disabled;
	let mainContactName = "Main Contact";
	$: {
		if (contact.FirstName && contact.Surname) {
			mainContactName = `${contact.FirstName} ${contact.Surname}`;
		} else if (contact.FirstName) {
			mainContactName = contact.FirstName;
		} else if (contact.Surname) {
			mainContactName = contact.Surname;
		} else {
			mainContactName = "Main Contact";
		}
	}

	const sameContactDetails = (index) => {
		jointHoldings[index].JointHoldingContact.PhoneNumber = contact.PhoneNumber;
		jointHoldings[index].JointHoldingContact.EmailAddress = contact.EmailAddress;
		Object.keys(contact.Address).forEach((key, i) => {
			jointHoldings[index].JointHoldingContact.Address[key] = contact.Address[key];
		});
	};

	const handleToggleSameAsContact = (event) => {
		if (event.target.checked) {
			disableJoint1 = true;
			jointHoldings[0].SameAsContact = true;
			jointHoldings[0].JointHoldingContact = contact;
		} else {
			disableJoint1 = null;
			jointHoldings[0].SameAsContact = false;
			jointHoldings[0].JointHoldingContact = getJointHoldingContact();
		}
	};

	const initialise = () => {
		if (!jointHoldings) jointHoldings = [];

		//  Add two Joint Holdings
		if (jointHoldings.length < 2) {
			jointHoldings.push(getJointHolding());
			jointHoldings.push(getJointHolding());
		}

		if (jointHoldings[0].SameAsContact) {
			disableJoint1 = true;
		}
	};

	const getJointHolding = () => {
		let jointHolding = {
			SameAsContact: false,
			JointHoldingContact: getJointHoldingContact()
		};

		return jointHolding;
	};

	const getJointHoldingContact = () => {
		let jointHoldingContact = new ContactModel();
		jointHoldingContact.Address = new AddressModel();

		return jointHoldingContact;
	};

	initialise();
</script>

{#if jointHoldings && jointHoldings.length >= 2}
	<h3>Joint Holding Details</h3>

	<FormRow>
		<FormColumn>
			{#if !isRegistrationUpdate}
				<Checkbox
					{disabled}
					change={(event) => handleToggleSameAsContact(event)}
					bind:checked={jointHoldings[0].SameAsContact}
					label="Are you a joint holder?"
					id="iscontact"
				></Checkbox>
			{:else}
				<Checkbox
					disabled
					bind:checked={jointHoldings[0].SameAsContact}
					label="Are you a joint holder?"
					id="iscontact"
				></Checkbox>
			{/if}
		</FormColumn>
	</FormRow>
	<FormRow>
		<FormColumn cols="6">
			<h3>Joint Holder 1</h3>
		</FormColumn>
		<FormColumn cols="6" class="last">
			{#if !disableJoint1}
				<button
					class="btn btn-primary btn-add-holdings btn-sm"
					on:click|preventDefault={() => sameContactDetails(0)}
					>Same contact details as {mainContactName}</button
				>
			{/if}
		</FormColumn>
	</FormRow>

	{#if jointHoldings[0].SameAsContact}
		<Contact
			title={contact.Title}
			firstName={contact.FirstName}
			surname={contact.Surname}
			emailAddress={contact.EmailAddress}
			phoneNumber={contact.PhoneNumber}
			address={contact.Address}
			disabled={disableJoint1}
			{required}
			idPrefix="j1"
		></Contact>
	{:else}
		<Contact
			bind:title={jointHoldings[0].JointHoldingContact.Title}
			bind:firstName={jointHoldings[0].JointHoldingContact.FirstName}
			bind:surname={jointHoldings[0].JointHoldingContact.Surname}
			bind:emailAddress={jointHoldings[0].JointHoldingContact.EmailAddress}
			bind:phoneNumber={jointHoldings[0].JointHoldingContact.PhoneNumber}
			bind:address={jointHoldings[0].JointHoldingContact.Address}
			disabled={disableJoint1}
			{required}
			idPrefix="j1"
		></Contact>
	{/if}

	<FormRow>
		<FormColumn cols="6">
			<h3>Joint Holder 2</h3>
		</FormColumn>
		<FormColumn cols="6" class="last">
			{#if !disabled}
				<button
					class="btn btn-primary btn-add-holdings btn-sm"
					on:click|preventDefault={() => sameContactDetails(1)}
					>Same contact details as {mainContactName}</button
				>
			{/if}
		</FormColumn>
	</FormRow>

	<Contact
		bind:title={jointHoldings[1].JointHoldingContact.Title}
		bind:firstName={jointHoldings[1].JointHoldingContact.FirstName}
		bind:surname={jointHoldings[1].JointHoldingContact.Surname}
		bind:emailAddress={jointHoldings[1].JointHoldingContact.EmailAddress}
		bind:phoneNumber={jointHoldings[1].JointHoldingContact.PhoneNumber}
		bind:address={jointHoldings[1].JointHoldingContact.Address}
		{disabled}
		{required}
		idPrefix="j2"
	></Contact>
{/if}

<FormRow>
	<FormColumn>
		<Checkbox
			{disabled}
			bind:checked={authorisedToAct}
			label="I am authorised to act on behalf of the Joint Holder"
			{required}
			id="authjh"
		></Checkbox>
	</FormColumn>
</FormRow>
